import React from 'react';
import { rpeInk, rpeTint } from './helpers';
import { SFm } from './tokens';

interface RpeChipProps {
  value: number | string | null | undefined;
}

const RpeChip: React.FC<RpeChipProps> = ({ value }) => {
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 999,
        background: rpeTint(value),
        color: rpeInk(value),
        fontFamily: SFm,
        fontSize: 11.5,
        fontWeight: 700,
        minWidth: 24,
        textAlign: 'center'
      }}
    >
      {value ?? '—'}
    </span>
  );
};

export default RpeChip;
